<template>
  <span v-if="statusOptions" class="badge-container">
    <span :class="`${value.name}-${value.class} status-badge `" v-for="(value, index) in displayRow" :key="index">{{
      value.name
    }}</span>
  </span>
  <div v-else style="height:1rem; padding:0; font-size: xx-small;">
    <p>fetching status options...</p>
  </div>
  <!--p class="debug">displayRow = {{ displayRow }}</p-->
</template>

<script setup lang="ts">
import { ref, computed, onMounted} from 'vue';
import { useStatusStore } from '@/stores/status-store.ts'
const props = defineProps({
  statusArr: Array<string>
})
const statusStore = useStatusStore();
const statusOptions = ref<String[] | undefined>();

onMounted(async() => {
  console.log('Project-status component mounted...')
  const fetched = await statusStore.getAll();
  statusOptions.value = fetched.map(option =>{
    return option.name;
  })

  //fetchTags();
})
/*
const options = [
  'QUOTE',
  'DESIGN',
  'REVIEWED',
  'INVOICED',
  'INSPECTION',
  'CLOSEOUT',
  'PAID'
]*/
//make array with empty entries
const displayRow = computed(()=>{
  return statusOptions.value.map(el=>{
    let temp = {};
    temp.name = el;
    temp.class = props.statusArr?.includes(el) ? 'show' : 'hidden';
    return temp;
  })

});

</script>






<style lang="css" scoped>
.badge-container {
  border: none;
  padding: 0.25rem;
}

div {
  padding: 0.25rem;
}
span {
  border: 1px solid black;
  border-radius: 0.7rem;
  padding: 0.25rem;
  margin: 0.25rem;
  font-size: xx-small;
}

/*
.status-badge {
    height: 30px;
    width: 120px;
    color: white;
    
  }*/

.IFC-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}

.INVOICED-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}

.CLOSEOUT-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}

.QUOTE-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}

.REVIEWED-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}

.INSPECTION-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}

.PAID-hidden{
  /*display:hidden;*/
  color : rgba(100,100,100,0.5);
  border: 1px solid rgba(100,100,100,0.5);
}



.IFC-show{
  background-color: yellow;
  color: black;
}

.INVOICED-show {
  background-color: purple;
  color: white;
}

.CLOSEOUT-show {
  background-color: blue;
  color: white;
}

.QUOTE-show {
  background-color: pink;
  color: black;
}

.CANCELLED {
  background-color: red;
  color: white;
}

.REVIEWED-show {
  background-color: green;
  color: white;
}
.INSPECTION-show {
  background-color: blueviolet;
  color: white;
}
.PAID-show {
  background-color: orangered;
  color: white;
}
.EMPTY{

  display:hidden;
}
</style>
